import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
var CLASS_NAME = 'asc-btn';
var propTypes = {
  /**
   * Text to display on button
   **/
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Forwards a ref from the parent to the native button element
   */
  buttonRef: PropTypes.object,
  /**
   * Class appended to asc-btn; Options: asc-btn--secondary, asc-btn--teritary, asc-btn--small, asc-btn--link, asc-btn--dropdown, asc-btn--icon, asc-btn--left, asc-btn--right, or any other class name
   **/
  className: PropTypes.string,
  /**
   * Function to execute on click
   **/
  clickHandler: PropTypes.func,
  /**
   * Additional attributes for the button element
   **/
  customAttrs: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])),
  /**
   * Is disabled
   **/
  disabled: PropTypes.bool,
  /**
   * Icon element to display alongside button text
   */
  icon: PropTypes.element,
  /**
   * Icon alignment - either left or right of button text
   */
  iconAlignment: PropTypes.oneOf(['left', 'right']),
  /**
   * Text displayed while the button is in its loading state
   */
  loadingText: PropTypes.string,
  /**
   * Unique DOM ID for automated tests to locate the button element
   */
  qaId: PropTypes.string,
  /**
   * Button Type; Options: button, submit, reset
   **/
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * Overrirde for displaying loader
   **/
  showLoading: PropTypes.bool
};
var defaultProps = {
  type: 'button',
  className: '',
  disabled: false,
  clickHandler: function clickHandler() {},
  customAttrs: {},
  iconAlignment: 'right',
  showLoading: false,
  qaId: '',
  loadingText: 'Processing...'
};
var Button = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Button, _Component);
  function Button(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.onClick = function (event) {
      var clickHandler = _this.props.clickHandler;
      var handler = clickHandler(event);
      if (handler && handler instanceof Promise) {
        _this.setState({
          isPendingResolve: true
        });
        handler.then(function () {
          _this.setState({
            isPendingResolve: false
          });
        }).catch(function () {
          _this.setState({
            isPendingResolve: false
          });
        });
      }
    };
    _this.state = {
      isPendingResolve: false
    };
    return _this;
  }
  var _proto = Button.prototype;
  _proto.render = function render() {
    var _classNames;
    var _this$props = this.props,
      buttonRef = _this$props.buttonRef,
      type = _this$props.type,
      className = _this$props.className,
      customAttrs = _this$props.customAttrs,
      disabled = _this$props.disabled,
      icon = _this$props.icon,
      iconAlignment = _this$props.iconAlignment,
      text = _this$props.text,
      qaId = _this$props.qaId,
      loadingText = _this$props.loadingText,
      showLoading = _this$props.showLoading;
    var content = text;
    var alignIconLeft = iconAlignment === 'left';
    if (icon) {
      content = alignIconLeft ? /*#__PURE__*/React.createElement(React.Fragment, null, icon, text) : /*#__PURE__*/React.createElement(React.Fragment, null, text, icon);
    }
    var classnames = classNames(CLASS_NAME, (_classNames = {}, _defineProperty(_classNames, className, Boolean(className)), _defineProperty(_classNames, 'is-loading', showLoading || this.state.isPendingResolve), _defineProperty(_classNames, 'asc-btn--icon-right', icon && !alignIconLeft), _defineProperty(_classNames, 'asc-btn--icon-left', icon && alignIconLeft), _classNames));
    return /*#__PURE__*/React.createElement("button", _extends({
      type: type,
      className: classnames,
      "data-qa": qaId,
      disabled: disabled === true || this.state.isPendingResolve,
      onClick: this.onClick,
      ref: buttonRef
    }, customAttrs), showLoading || this.state.isPendingResolve ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("svg", {
      className: "asc-loader",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 52 52"
    }, /*#__PURE__*/React.createElement("circle", {
      className: "asc-loader-circle",
      cx: "26",
      cy: "26",
      r: "25",
      fill: "none"
    })), loadingText) : content);
  };
  return Button;
}(Component);
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
export default Button;